import { render } from "./pc_report_past_component.vue?vue&type=template&id=b95c083a&scoped=true"
import script from "./pc_report_past_component.vue?vue&type=script&scoped=true&lang=js"
export * from "./pc_report_past_component.vue?vue&type=script&scoped=true&lang=js"

import "./pc_report_past_component.vue?vue&type=style&index=0&id=b95c083a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b95c083a"]])

export default __exports__